import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["linksContainer", "linkTemplate", "linkFields"];

  connect() {}

  addLink(event) {
    event.preventDefault();
    const content = this.linkTemplateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    );
    this.linksContainerTarget.insertAdjacentHTML("beforeend", content);
  }

  removeLink(event) {
    event.preventDefault();
    const wrapper = event.target.closest(".social-media-link");
    if (!wrapper) return;

    const destroyInput = wrapper.querySelector('input[name*="[_destroy]"]');
    if (destroyInput) {
      destroyInput.value = "1";
      wrapper.style.display = "none";
    } else {
      wrapper.remove();
    }
  }
}
